import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "next-milestone bg-white rounded-3 mt-3" }
const _hoisted_2 = { class: "next-milestone__label" }
const _hoisted_3 = { class: "next-milestone__body" }
const _hoisted_4 = { class: "d-flex flex-wrap align-center" }
const _hoisted_5 = { class: "next-milestone__name" }
const _hoisted_6 = {
  key: 0,
  class: "next-milestone__hint"
}
const _hoisted_7 = {
  key: 1,
  class: "d-flex flex-wrap next-milestone__actions"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import { computed } from 'vue'
import { format } from 'date-fns'
import { Milestone } from '../../../api/v2/models/user_goal'
import MilestoneTeacherCheck from './MilestoneTeacherCheck.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NextMilestoneCard',
  props: {
    milestone: {}
  },
  emits: ["to-course", "to-exam"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const unfinishedCourses = computed(() => props.milestone.enrollments.filter((e) => e.progressPercent < 100))

function shortDate(date: string): string {
  return format(date, 'M/D')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" 生徒のゴール画面の「次にやること」：期限の早い、まだ終わっていない宿題（マイルストーン）を1つ "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_icon, {
          size: "18",
          class: "me-1"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("mdi-flag-variant-outline", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }),
        _cache[1] || (_cache[1] = _createTextVNode("次にやること ", -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.milestone.name), 1 /* TEXT */),
          _createVNode(MilestoneTeacherCheck, {
            check: __props.milestone.teacherCheck,
            part: "badge"
          }, null, 8 /* PROPS */, ["check"]),
          (__props.milestone.targetDate)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["next-milestone__due", { 'is-over': __props.milestone.status === 'overdue' }])
              }, _toDisplayString(__props.milestone.status === 'overdue' ? '期限を過ぎています' : '期限') + " " + _toDisplayString(shortDate(__props.milestone.targetDate)), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true)
        ]),
        (__props.milestone.status === 'passed')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 確認テストは合格です。先生のチェックを待っています。 "))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unfinishedCourses.value, (enrollment) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: `c${enrollment.id}`,
                  type: "button",
                  class: "next-milestone__btn is-primary",
                  onClick: ($event: any) => (emit('to-course', enrollment.course.id.toString()))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    class: "me-1"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-book-open-page-variant-outline", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _cache[3] || (_cache[3] = _createTextVNode(" 教材を開く", -1 /* CACHED */)),
                  _createElementVNode("small", null, _toDisplayString(enrollment.course.name) + "・" + _toDisplayString(enrollment.progressPercent) + "%", 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_8))
              }), 128 /* KEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.milestone.exams, (exam) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: `e${exam.id}`,
                  type: "button",
                  class: "next-milestone__btn",
                  onClick: ($event: any) => (emit('to-exam', exam.id.toString()))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    class: "me-1"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-clipboard-check-outline", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _createTextVNode(" " + _toDisplayString(exam.hasUserExam ? 'テストをもう一度' : '確認テストを受ける'), 1 /* TEXT */),
                  _createElementVNode("small", null, _toDisplayString(exam.name), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
      ])
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})